import { render, staticRenderFns } from "./NewExpenseAdd.vue?vue&type=template&id=0aea908a"
import script from "./NewExpenseAdd.vue?vue&type=script&lang=js"
export * from "./NewExpenseAdd.vue?vue&type=script&lang=js"
import style0 from "./NewExpenseAdd.vue?vue&type=style&index=0&id=0aea908a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports